import React from 'react';
import { Link } from 'react-router-dom';

const capabilities = [
  'Porta Cabins',
  'Site Offices',
  'Guard Cabins',
  'False Ceilings',
  'Gypsum Work',
  'ACP Services',
  'Partitions',
  'Containers',
  'Farm Houses',
  'Shades & MS Structures',
];

const values = [
  {
    title: 'Integrity',
    description: 'We operate with honesty and transparency in everything we do.',
  },
  {
    title: 'Excellence',
    description: 'We strive for the highest quality in our work and client relationships.',
  },
  {
    title: 'Innovation',
    description: 'We embrace modern engineering and continuously seek better solutions.',
  },
  {
    title: 'Collaboration',
    description: 'We work closely with clients and teams to deliver successful projects.',
  },
];

function AboutUs() {
  return (
    <div className="page">
      <header className="page-header">
        <span className="page-eyebrow">Our Story</span>
        <h1 className="page-title">About Adhunik Prefab Systems</h1>
        <p className="page-subtitle">
          Leading manufacturers of high-quality customizable prefab structures for industrial,
          commercial, and site requirements across India.
        </p>
      </header>

      <div className="about-content">
        <div className="about-text">
          <p>
            Adhunik Prefab Systems are the leading manufacturers of high quality customizable porta
            cabins designed to meet your specific needs. From construction sites to remote locations,
            our durable and cost-effective solutions serve temporary and permanent requirements alike.
          </p>
          <p>
            We provide the best range of false ceilings, guard porta cabins, ACP work services, site
            offices, gypsum ceiling work, and farm houses — all tailored to your project specifications.
          </p>
          <p>
            Portable rooms and site offices in cement board, ACP sheet, and puff panel. Partitions in
            gypsum board, puff panels, wood with ply, toughened glass, and aluminium. False ceilings in
            grid, gypsum, and PVC. Containers in MS sheet with PVC and wooden interior work. Shades in
            color-coated profile sheet with MS structure.
          </p>
          <div className="capabilities-list">
            {capabilities.map((item) => (
              <span key={item} className="capability-tag">
                {item}
              </span>
            ))}
          </div>
        </div>
        <div className="about-image">
          <img src="/ourteams.png" alt="Adhunik Prefab Systems team at work" />
        </div>
      </div>

      <div className="mission-block">
        <div className="mission-card">
          <h2>Who We Are</h2>
          <p>
            At Adhunik Prefab Systems, we are pioneers in off-site construction technology. With a
            commitment to &quot;Adhunik&quot; (Modern) engineering, we bridge the gap between traditional
            craftsmanship and contemporary speed. We specialize in the design, fabrication, and
            installation of prefabricated structures for industrial and commercial sectors.
          </p>
        </div>
        <div className="mission-card">
          <h2>Our Mission</h2>
          <p>
            To provide eco-friendly, cost-effective, and durable structural solutions that empower
            businesses to scale rapidly without compromising on architectural integrity.
          </p>
          <p className="mission-tagline">
            &ldquo;Transform your space into a Portable Solution&rdquo;
          </p>
        </div>
      </div>

      <section className="section">
        <h2 className="section-title">Our Core Values</h2>
        <div className="card-grid">
          {values.map((value) => (
            <div key={value.title} className="value-item">
              <h4>{value.title}</h4>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-band">
        <h2>Partner With Us on Your Next Project</h2>
        <p>Explore our full range of products or reach out for a customized quote.</p>
        <div className="cta-actions">
          <Link to="/productservices" className="btn btn-primary">
            View Products
          </Link>
          <Link to="/contact" className="btn btn-outline">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
